<template>
    <div id="AppoinmentTypeLIST">
     <h4 class="page-title text-truncate">
           {{$tc('Shared.AppointmentType', 2) }}                 
      </h4>
      <div class="row">
                <div class="col-sm-12 col-md-3"  v-if="hasPermissionAdd()">                      
                      <MdButton
                        v-bind:Label="$t('Shared.Add')" 
                        v-bind:ClassProp="'btn btn-primary my-3 btn-block btn-login'"
                        v-bind:IconClass="'ti-plus pr-1'"
                        v-on:click="AddAppoinmentType"                   
                        v-bind:Name="'btn_addAppoinmentType'">
                      </MdButton>
                  </div>
                  <div v-bind:class="hasPermissionAdd() ? 'col-sm-12 col-md-9 mb-4':'col-sm-12 col-md-12 mb-4'">
                      <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                          <div class="input-group" dir="ltr">
                              <input 
                                type="text" 
                                class="form-control"
                                :dir="dirInput"
                                v-model="parameter.SearchCriteria"   
                                @keyup.enter="SearchAppoinmentType"                            
                              >
                              <div class="input-group-append">
                                  <div class="input-group-append">
                                  <MdButton 
                                    v-bind:Name="'btnsearchinput'"
                                    v-bind:VariantProp="'btn btn-sm search-attached'"
                                    v-bind:IconClass="'mdi mdi-magnify'"
                                    v-on:click="SearchAppoinmentType">
                                  </MdButton>
                              </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  
              </div> 
  
        <div class="row">
          <div class="col-12 mt-2">
          <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
            <div class="row">
              <div class="col-md-12">
                <MdTable 
                  v-bind:fields="fields"
                  v-bind:items="items"
                  v-bind:totalRows="totalRows"
                  v-bind:isReadOnly="false"
                  v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                  v-bind:currentPage="currentPage"
                  v-bind:perPage="perPage"
                  v-bind:pageOptions="pageOptions"
                  :editIconEvent="EditAppoinmentType"
                  v-bind:VisibleEditIcon="hasPermissionEdit()"
                  :deleteIconEvent="RemoveAppoinmentType"
                  v-bind:VisibleDeleteIcon="hasPermissionDelete()"
                  :onRowSelected="onRowSelected"
                  :onFiltered="onFiltered"
                  :pageChanged="pageChanged"
                  :perPageFunction="PerPageFunction">
                </MdTable>
              </div>
            </div>
          </div>
        </div>
          
    </div>
</template>
  
  <script>
  import DBFunctions from '@/common/DBFunctions.js'
  import ShowMessage from '@/components/messages/ShowMessage.js'
  import AppoinmentTypeService from '@/services/appointmenttypes.service'
  import Permission from '@/common/Permission'
  import TherapyCategoriesService from '@/services/therapycategories.service'
  import HealthProtocolService from '@/services/healthprotocol.service'
  import ClinicalService from '@/services/clinical.service'
  
  export default {
    name: 'AppoinmentTypeLIST',
    mixins: [ShowMessage, DBFunctions, Permission],
    data(){
      return{
        //permission: [],
        //Menu : this.$store.state.leftMenu,
        parameter:{
          SearchCriteria:'',
          PageNumber : 0,
          PageSize:0, 
          Type:''        
        },
         OptionsRightMenu:{
            visible:false,
            ItemsList:[],
            btnvisible:false,
            itemdisabled: false,
            PatientCode:'',
            Mode:this.edit_mode,
            favButtonAtion:false          
          },
        totalRows: 0,
        currentPage: 1,
        perPage: 10,
        ShowMessageIsEmpty:false,
        pageOptions: [5, 10, 15 ],
        items:[],
        typeModel:{text:this.$t('Shared.All'),value:'All'},
        TypeList:[
          {text:this.$t('Shared.All'),value:'All'},
          {text:this.$t('Shared.CPT'),value:'CPT'},
          {text:this.$t('Shared.HCPCS'),value:'HCPCS'},
          {text:this.$t('cpt.Revenue'),value:'Revenue'},
          {text:this.$t('cpt.UserDefined'),value:'UserDefined'},
        ],
        fields: [
          { key: 'description', sortable: true, label: this.$t('Shared.Description'), class: 'text-rigth' },      
          { key: 'code', sortable: true, label: this.$t('Shared.Code'), class: 'text-rigth'},  
          { key: 'therapyCode', sortable: true, label: this.$t('insuranceSetup.tCode'), class: 'text-rigth'},  
          { key: 'therapyDesc', sortable: true, label: this.$t('Shared.Therapy'), class: 'text-rigth'},       
          { key: 'duration', sortable: true, label: this.$t('Shared.Duration'), class: 'text-rigth' },
          { key: 'healthprotocol', sortable: true, label: this.$t('appoType.healthprotocol'), class: 'text-rigth'},      
          { key: 'billableAppt', sortable: true, label: this.$t('appoTypeList.bAppt'), class: 'text-rigth',formatter: value => {return value ? 'Y' : 'N'} },       
          ],
          dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
      }
    },
  
    methods:{
  
      ChangeType(type){
        this.typeModel = type;
        this.getAppoinmentType();
      },
  
      AddAppoinmentType(){
         this.emitDataforFavorites(); 
         this.$router.push({ name: "appointmenttypes-add", params: { id: this.$route.params.id } }).catch(()=>{});
      },
  
    SearchAppoinmentType(){
        this.items = []
        this.currentPage = 1;
        this.parameter.PageNumber = 1;
        this.totalRows = this.items.length;
        this.getAppoinmentType();
      },
  
      EditAppoinmentType(row){ 
         this.$router.push({ name: "appointmenttypes-details", params: { id: row.code } });    
      },
  
      RemoveAppoinmentType(row){
         const Id = row.code;
             this.$bvModal.msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
                title:  this.$tc('Shared.DelRecord'),
                okTitle: this.$t('Shared.TitleDelete'),
                cancelTitle: this.$t('Shared.BtnCancel'),
                footerClass: 'p-2',
                titleClass: 'modal-title modal-type-warning',
                id: 'modal_delete_AppoinmentType'
            })
            .then(value => {
              if(value){
                AppoinmentTypeService.Delete(Id)
                  .then(() => {
                    const index = this.items.findIndex(item => item.code === Id) 
                    if (~index) {
                      this.items.splice(index, 1) 
                      this.getAppoinmentType(); 
                    }
                  })
                  .catch((error) => {
                    this.showResponseErrorMessage(error);
                  });
              }
            })
      },
  
      onRowSelected(){
  
      },
      onFiltered(){
  
      },
      pageChanged(page){
        this.currentPage = page;    
        this.getAppoinmentType();  
      },
      PerPageFunction(perpage){
        this.perPage = perpage;  
        this.currentPage = 1;
        this.getAppoinmentType();  
      },

      async getAppoinmentType() {
        this.parameter.PageNumber = this.currentPage;           
        this.parameter.PageSize = this.perPage;      
        this.parameter.Type = this.typeModel ? this.typeModel.value : '';

        try {
            const response = await AppoinmentTypeService.getAllEmployees(this.parameter);
            
            if (response.status == '200' && response.data) {
                // Limpiar items antes de llenar con nueva página
                this.items = [];
                
                // IMPORTANTE: Esperar a que TODAS las descripciones se resuelvan
                const itemsWithDescriptions = await this.enrichItemsWithDescriptions(response.data);
                this.items = itemsWithDescriptions;
                
                // Procesar paginación
                let headerString = response.headers["x-pagination"];
                if (headerString) {
                    const header = JSON.parse(headerString);
                    this.totalRows = header.TotalCount;
                }
            }
            
            this.showMessageIsEmpty = this.totalRows === 0 || this.items.length === 0;
            
        } catch (error) {
            console.error('Error en getAppoinmentType:', error);
            this.showResponseErrorMessage(error);
        } finally {
            // this.loading = false;
        }
    },

    // Método separado para enriquecer items
    async enrichItemsWithDescriptions(items) {
        if (!items || items.length === 0) return [];
        
        // Crear un array de promesas para TODOS los items
        const enrichmentPromises = items.map(async (element) => {
            // Crear una copia para no modificar el original directamente
            const enrichedItem = { ...element };
            
            try {
                // Obtener todas las descripciones necesarias para este item
                const descriptions = await this.getAllDescriptionsForItem(element);
                
                // Asignar las descripciones al item enriquecido
                if (descriptions.therapy) {
                    enrichedItem.therapyDesc = descriptions.therapy;
                }
                if (descriptions.defaultTherapy) {
                    enrichedItem.deTherapy = descriptions.defaultTherapy;
                }
                if (descriptions.healthProtocol) {
                    enrichedItem.healthprotocol = descriptions.healthProtocol;
                }
                
            } catch (error) {
                console.error(`Error en item ${element.id}:`, error);
                // No fallar todo por un item
            }
            
            return enrichedItem;
        });
        // Wait for all promise finish
        return await Promise.all(enrichmentPromises);
    },

    // Método para obtener todas las descripciones de un item individual
    async getAllDescriptionsForItem(item) {
        const descriptions = {};
        
        // Obtener descripción de terapia
        if (item.therapyCode) {
            try {
                const response = this.useCategory 
                    ? await TherapyCategoriesService.get(item.therapyCode)
                    : await ClinicalService.getTherapy(item.therapyCode);
                descriptions.therapy = response.data?.name || null;
            } catch (error) {
                console.error(`Error obteniendo terapia para ${item.therapyCode}:`, error);
                descriptions.therapy = null;
            }
        }
        // Obtener descripción de terapia por defecto
        if (item.defaultTherapyCode) {
            try {
                const response = await ClinicalService.getTherapy(item.defaultTherapyCode);
                descriptions.defaultTherapy = response.data?.name || null;
            } catch (error) {
                console.error(`Error obteniendo terapia por defecto para ${item.defaultTherapyCode}:`, error);
                descriptions.defaultTherapy = null;
            }
        }
        // Obtener descripción de protocolo de salud
        if (item.healthProtocolCode) {
            try {
                const response = await HealthProtocolService.get(item.healthProtocolCode);
                descriptions.healthProtocol = response.data?.description || null;
            } catch (error) {
                console.error(`Error obteniendo protocolo de salud para ${item.healthProtocolCode}:`, error);
                descriptions.healthProtocol = null;
            }
        }
        return descriptions;
    },

    // Método opcional: getAllDescription para casos específicos (similar al original)
    async getAllDescriptionForType(code, type) {
        try {
            let response;
            switch(type) {
                case 'therapy':
                    response = this.useCategory 
                        ? await TherapyCategoriesService.get(code)
                        : await ClinicalService.getTherapy(code);
                    return response.data?.name || null;
                    
                case 'defaultTherapy':
                    response = await ClinicalService.getTherapy(code);
                    return response.data?.name || null;
                    
                case 'healthProtocol':
                    response = await HealthProtocolService.get(code);
                    return response.data?.description || null;
                    
                default:
                    return null;
            }
        } catch (error) {
            console.error(`Error obteniendo descripción para ${code} (${type}):`, error);
            this.showResponseErrorMessage(error);
            return null;
        }
      }
    },
    
     mounted(){
          this.OptionsRightMenu.ItemsList = [];
         let layoutStatus = this.$store.state.layoutStatus;
         switch(layoutStatus) {
          case 'L0R1':
            this.OptionsRightMenu.favButtonAtion = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
          break;
          case 'L1R0':
          case 'L1R1':
              this.OptionsRightMenu.btnvisible = false;
              this.$emit('getVisibleMenu', this.OptionsRightMenu);
          break;
          default:
              this.OptionsRightMenu.favButtonAtion = false;
              this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }
      this.getAppoinmentType();
    },
  
     destroyed(){
        this.OptionsRightMenu.ItemsList = [];
        this.OptionsRightMenu.Mode = false;
        this.OptionsRightMenu.visible = false; 
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
      }
     
  };
  </script>
  
  